<template>
  <tr>
    <slot></slot>
  </tr>
</template>
